import { EDealType, EOfferType } from 'shared/types/wantType';

export const formatDeal = (deal: EDealType) => {
  if (deal === EDealType.Sale) {
    return 'продаже';
  }

  return 'сдаче';
};

export const formatOffer = (offer: EOfferType) => {
  if (offer === EOfferType.Apartment) {
    return 'квартиры';
  }

  return 'дома';
};
